import { render, staticRenderFns } from "./Staging-View-Details.vue?vue&type=template&id=6833cfd0&scoped=true&"
import script from "./Staging-View-Details.vue?vue&type=script&lang=js&"
export * from "./Staging-View-Details.vue?vue&type=script&lang=js&"
import style0 from "./Staging-View-Details.vue?vue&type=style&index=0&id=6833cfd0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6833cfd0",
  null
  
)

export default component.exports